import { Transition } from '@goodboydigital/astro';

export class NoTransition implements Transition
{
    autoManageContainers = true;

    hide(): Promise<void>
    {
        return Promise.resolve();
    }

    show(): Promise<void>
    {
        return Promise.resolve();
    }
}
